/**
 * How the modal's Download action starts a download. Which one applies is decided by the host
 * (it knows the environment); the modal only carries it out.
 */
export const ATTACHMENT_DOWNLOAD_MODE = {
    /**
     * A link to the attachment URL that also carries the `download` attribute, so the browser keeps
     * its own handling. Browsers that do not honour the attribute for a cross-origin URL ignore it
     * and rely on the URL's `Content-Disposition: attachment`, which is what happened before.
     */
    LINK: 'link',
    /**
     * The click is intercepted and the download is started by clicking a hidden anchor that has the
     * `download` attribute (iOS / iPadOS browsers). The modal is left exactly as it was.
     */
    PROGRAMMATIC: 'programmatic',
    /**
     * A plain link with no `download` attribute and no interception: for a host webview that
     * handles links natively, where adding anything could change what its navigation delegate sees.
     */
    NATIVE: 'native'
};
/**
 * Start a download by clicking a throwaway anchor with the `download` attribute. It is never given a
 * `target`, so no window or tab is opened (a host webview may load a new window inside the chat,
 * replacing it). Must be called from the click that asked for it: browsers only honour a
 * download that follows a user gesture.
 */
export function startAnchorDownload(url, fileName) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.rel = 'noopener';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}
